import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/general/nsc/RichText.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/components/icons/Arrow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/questionnaire/QuestionnaireCardRenderer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/voting/ElectionCardRenderer.tsx");
